export default {
  computed: {
    allDrivers() {
      return this.$store.state.DriverStore.all_drivers
    }
  }
}
